export default {
  EDIT_ORDER: 'EDIT_ORDER',
};
